export const EyeIcon = ({ className, size = 20, color = "#212529", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      // The artwork is drawn in a fixed 20x20 coordinate space, so the viewBox
      // stays 20x20 and `size` only scales it. Deriving the viewBox from `size`
      // instead crops the icon at any size other than 20.
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_12923_3664)">
        <path
          d="M10.0005 3.75C14.1668 3.75013 17.7248 6.34201 19.1665 10C17.7249 13.6582 14.167 16.2499 10.0005 16.25C5.83382 16.25 2.27516 13.6583 0.833496 10C2.27526 6.34186 5.83396 3.75 10.0005 3.75ZM10.0005 5.83398C7.70063 5.83398 5.83372 7.70019 5.8335 10C5.8335 12.3 7.70049 14.167 10.0005 14.167C12.3003 14.1668 14.1665 12.2999 14.1665 10C14.1663 7.7003 12.3002 5.83416 10.0005 5.83398ZM10.0005 7.5C11.3835 7.50017 12.5003 8.61697 12.5005 10C12.5005 11.3832 11.3837 12.4998 10.0005 12.5C8.61716 12.5 7.50049 11.3833 7.50049 10C7.50071 8.61686 8.61729 7.5 10.0005 7.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_12923_3664">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}; 